import { logger } from "@/lib/logger";

const SHEETS_WEBHOOK_URL =
  "https://script.google.com/macros/s/AKfycbzCNwo9razIir7SkQOe9BIlnxZ20i9U3JJF6vOcr0DkMeIGHm_z3nyJTXmgaq-6DNFXiw/exec";

export interface QuestionMeta {
  category: string;
  question: string;
  options: { value: number; label: string }[];
}

export interface DiagnosticSubmission {
  name: string;
  email: string;
  countryCode: string;
  whatsapp: string;
  totalScore: number;
  answers: Record<number, number>;
  questions?: QuestionMeta[];
}

export async function saveDiagnosticLead(data: DiagnosticSubmission) {
  try {
    // no-cors avoids CORS preflight; Apps Script receives the payload as text
    await fetch(SHEETS_WEBHOOK_URL, {
      method: "POST",
      mode: "no-cors",
      headers: { "Content-Type": "text/plain;charset=utf-8" },
      body: JSON.stringify(data),
    });
  } catch (err) {
    logger.error("Error sending lead to Sheets webhook:", err);
  }

  // Track Meta Pixel custom conversion event
  if (typeof window !== "undefined" && (window as any).fbq) {
    (window as any).fbq("trackCustom", "CompleteTest", {
      content_name: "Test Diagnóstico Capital de Marca",
      score: data.totalScore,
    });
  }

  return true;
}
